import React, { useRef } from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import Home from "../components/landing";
import Login from "../components/login";

export default function LoginPage() {
  return (
    <div>
      <NavBar/>
      <Login/>
      <Footer/>
    </div>
  );
}